import { apiRequest } from './client';

// Public
export const listPublishedPackages = (signal) => apiRequest('/api/packages', { signal });

export const sendPackageEnquiry = (packageId, enquiry) =>
  apiRequest(`/api/packages/${packageId}/enquiries`, { body: enquiry });

// Admin
export const adminListPackages = (token, category) =>
  apiRequest(`/api/admin/packages${category ? `?category=${category}` : ''}`, { token });

export const adminGetPackage = (token, packageId) =>
  apiRequest(`/api/admin/packages/${packageId}`, { token });

export const adminCreatePackage = (token, pkg) =>
  apiRequest('/api/admin/packages', { body: pkg, token });

export const adminUpdatePackage = (token, packageId, pkg) =>
  apiRequest(`/api/admin/packages/${packageId}`, { method: 'PUT', body: pkg, token });

export const adminDeletePackage = (token, packageId) =>
  apiRequest(`/api/admin/packages/${packageId}`, { method: 'DELETE', token });

export const adminListEnquiries = (token, page, pageSize) =>
  apiRequest(`/api/admin/package-enquiries?page=${page}&pageSize=${pageSize}`, { token });
